import dayjs from 'dayjs';

import dayjsDuration from 'dayjs/plugin/duration';
import dayjsUTC from 'dayjs/plugin/utc';
import dayjsLocaleData from 'dayjs/plugin/localeData';
import dayjsCustomParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(dayjsDuration);
dayjs.extend(dayjsUTC);
dayjs.extend(dayjsLocaleData);
dayjs.extend(dayjsCustomParseFormat);

export default async ({ store: { state } }) => {
  const { locale } = state.global || state;
  await import(/* webpackChunkName: "dayjs-locale-[request]" */ `dayjs/locale/${locale}.js`);
  dayjs.locale(locale);
};
